import { useOrganizationSource } from '../../../hooks/useOrganizationSource'
import { useSplitTest } from '../../../hooks/useSplitTest'
import { demoInvoiceEditorBuckets, demoInvoiceEditorCountries } from '../constants/demoInvoiceEditorBuckets'

export const useIsDemoInvoiceEditorEnabled = (): boolean => {
  const { isSourceZervant } = useOrganizationSource()
  const { isEnabled } = useSplitTest({
    buckets: demoInvoiceEditorBuckets,
    countries: demoInvoiceEditorCountries,
  })

  return isSourceZervant && isEnabled
}
